"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ThemeContext = /*#__PURE__*/_react["default"].createContext({});

function PictureComponent(props) {
  var imageSrc = props.imageSrc;

  var _a = (0, _utils.fomateFileData)(imageSrc),
      url = _a.url,
      _b = _a.alt,
      alt = _b === void 0 ? '' : _b;

  var _c = (0, _react.useState)({}),
      styles = _c[0],
      setStyls = _c[1];

  (0, _react.useEffect)(function () {
    var imgLoad = new Image();

    if (url) {
      imgLoad.src = url;
    }

    imgLoad.onload = function () {
      var collectStyles = {};

      if (imgLoad.width < imgLoad.height) {
        collectStyles = {
          height: '100%',
          width: 'auto'
        };
      } else {
        collectStyles = {
          width: '100%',
          height: 'auto'
        };
      }

      setStyls(collectStyles);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("img", {
    style: __assign({}, styles),
    src: url,
    alt: alt
  });
}

var FlexTab = function FlexTab(props) {
  var icon = props.icon,
      banner = props.banner,
      sharp = props.sharp,
      radius = props.radius,
      source = props.source,
      key = props.key,
      TabImageSrc = props.TabImageSrc,
      tabIndex = props.tabIndex,
      className = props.className,
      title = props.title,
      children = props.children,
      onClick = props.onClick,
      restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "key", "TabImageSrc", "tabIndex", "className", "title", "children", "onClick"]);

  var value = (0, _react.useContext)(ThemeContext);

  var compute = function compute() {
    var childrenParentNodes = value.inputEl.current;
    var childrenNodes = childrenParentNodes ? childrenParentNodes.childNodes || [] : []; // todo optimize

    for (var i = 0; i < childrenNodes.length - 1; i++) {
      if (i == 0) {
        var elementWidth = childrenNodes[i] && childrenNodes[i].offsetWidth;
        childrenNodes[childrenNodes.length - 1].style.left = i * elementWidth + "px";

        if (childrenNodes[i].childNodes[0]) {
          var childrenElementWidth = childrenNodes[i].childNodes[0].offsetWidth;
          childrenNodes[childrenNodes.length - 1].style.width = childrenElementWidth + "px";
        } // childrenNodesControlTabs[i].style.display = 'block';


        childrenNodes[i].className = 'ant-tabs-tab ant-tabs-tab-active';
      }
    }
  };

  (0, _react.useEffect)(function () {
    compute();
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", __assign({}, restProps, {
    className: (0, _classnames["default"])('ant-tabs-tab', {// 'ant-tabs-tab-active': classStatus
    }),
    "report-event": "click_storiesScenarios_tab",
    "report-ext1": tabIndex,
    "report-ext2": title || '',
    onClick: function onClick() {
      var childrenParentNodes = value.inputEl.current;
      var controlTabs = value.inputElCont.current;
      var childrenNodes = childrenParentNodes ? childrenParentNodes.childNodes || [] : [];
      var childrenNodesControlTabs = controlTabs ? controlTabs.childNodes || [] : []; // todo optimize

      for (var i = 0; i < childrenNodes.length - 1; i++) {
        if (i == tabIndex - 1) {
          var elementWidth = childrenNodes[i] && childrenNodes[i].offsetWidth;
          childrenNodes[childrenNodes.length - 1].style.left = i * elementWidth + "px";

          if (childrenNodes[i].childNodes[0]) {
            var childrenElementWidth = childrenNodes[i].childNodes[0].offsetWidth;
            childrenNodes[childrenNodes.length - 1].style.width = childrenElementWidth + "px";
          }

          childrenNodesControlTabs[i].style.display = 'block';
          childrenNodes[i].className = 'ant-tabs-tab ant-tabs-tab-active';
        } else {
          childrenNodesControlTabs[i].style.display = 'none';
          childrenNodes[i].className = 'ant-tabs-tab ';
        }
      }
    },
    key: key
  }), /*#__PURE__*/_react["default"].createElement("div", {
    role: "tab",
    "aria-selected": "true",
    className: 'ant-tabs-tab-btn',
    id: "rc-tabs-0-tab-1",
    "aria-controls": "rc-tabs-0-panel-1"
  }, /*#__PURE__*/_react["default"].createElement("div", null, TabImageSrc ? /*#__PURE__*/_react["default"].createElement(PictureComponent, {
    imageSrc: TabImageSrc
  }) : /*#__PURE__*/_react["default"].createElement("img", {
    src: 'https://staticintl.cloudcachetci.com/cms/backend-cms/rQmv565_Frame%20117.png',
    alt: "tencent cloud"
  })), /*#__PURE__*/_react["default"].createElement("span", null, title))));
};

var ArchitectureComponent = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
      banner = props.banner,
      sharp = props.sharp,
      radius = props.radius,
      source = props.source,
      className = props.className,
      children = props.children,
      onClick = props.onClick,
      restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "className", "children", "onClick"]);

  var collectChildren = [];

  _react.Children.forEach(children, function (item) {
    var _ = item ? item.props : null;

    collectChildren.push(_.children);
  });

  var inputEl = (0, _react.useRef)(null);
  var inputElCont = (0, _react.useRef)(null);
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref,
    className: (0, _classnames["default"])('flex-default-flex-default-customer-Tab', className)
  }, restProps), /*#__PURE__*/_react["default"].createElement(ThemeContext.Provider, {
    value: {
      inputEl: inputEl,
      inputElCont: inputElCont
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'ant-tabs'
  }, collectChildren && collectChildren.length > 1 ? /*#__PURE__*/_react["default"].createElement("div", {
    ref: inputEl,
    className: 'ant-tabs-list'
  }, _react.Children.map(children, function (item) {
    return item;
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'ant-tabs-ink-bar ant-tabs-ink-bar-animated',
    style: {
      left: 0,
      width: '36px'
    }
  })) : null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: inputElCont,
    className: 'ant-tabs-content-holder'
  }, _react.Children.map(collectChildren, function (item) {
    return item;
  })))));
});
ArchitectureComponent.displayName = 'TCIArchitectureComponent';
ArchitectureComponent.FlexTab = FlexTab;
var _default = ArchitectureComponent;
exports["default"] = _default;